/* src/app/views/plans-details-edit/coverage-details-edit/coverage-details-edit.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: left;
  margin-top: 20px;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.title-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  width: 100%;
}
.title {
  display: block;
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(28px, 2.2vw, 48px);
  line-height: 1.2;
  color: #333333;
  margin: 10px 0 0 48px;
}
.sub-title {
  display: block;
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(14px, 1.1vw, 22px);
  line-height: 1.3;
  color: #5f5f5f;
  margin-top: 2px;
}
.container-body {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  border: none;
}
.product-itens {
  padding: 8px 36px 0;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.product-itens > [class*=col-] {
  padding: 0 12px 16px;
}
.element-edit {
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-edit-input {
  margin-top: 5px;
  width: 100%;
  max-width: 100%;
}
.element-edit-label {
  margin-bottom: 5px;
}
.space-top {
  margin-left: 0;
}
.space-first {
  margin-left: 0;
}
.space-second {
  margin-left: 0;
}
.disabled-input:disabled {
  background-color: #F5F5F5;
  color: #999999;
}
.readonly-mode .disabled-input,
.readonly-mode .disabled-input:hover,
.readonly-mode .disabled-input:focus,
.readonly-mode .disabled-input:focus-visible {
  background-color: #F5F5F5 !important;
  color: #999999 !important;
  border-color: #E0E0E0 !important;
  box-shadow: none !important;
  outline: none !important;
}
.disabled-input:disabled,
.disabled-input:disabled:focus,
.disabled-input:disabled:focus-visible,
.disabled-input:disabled:hover {
  border-color: #E0E0E0 !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .p-dropdown.p-disabled,
:host ::ng-deep .p-dropdown.p-disabled:hover,
:host ::ng-deep .p-dropdown.p-disabled.p-focus {
  border-color: #E0E0E0 !important;
  box-shadow: none !important;
}
.readonly-mode ::ng-deep .p-dropdown,
.readonly-mode ::ng-deep .p-dropdown:hover,
.readonly-mode ::ng-deep .p-dropdown.p-focus {
  border-color: #E0E0E0 !important;
  background-color: #F5F5F5 !important;
  box-shadow: none !important;
}
.readonly-mode ::ng-deep .p-dropdown .p-dropdown-label,
.readonly-mode ::ng-deep .p-dropdown .p-dropdown-trigger {
  color: #999999 !important;
  background-color: #F5F5F5 !important;
}
.readonly-mode ::ng-deep .p-dropdown.p-disabled .p-dropdown-label,
.readonly-mode ::ng-deep .p-dropdown.p-disabled .p-dropdown-label.p-inputtext,
.readonly-mode ::ng-deep .p-dropdown.p-disabled .p-inputtext,
.readonly-mode ::ng-deep .p-dropdown.p-disabled .p-dropdown-trigger,
.readonly-mode ::ng-deep .p-dropdown.p-disabled .p-dropdown-trigger-icon {
  color: #999999 !important;
  background-color: #F5F5F5 !important;
  opacity: 1 !important;
}
.message-edit {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: initial;
  width: calc(100% + 24px);
  margin: 0 -12px;
  padding: 0;
}
.message-edit > [class*=col-] {
  padding: 0 12px 16px;
}
.element-edit > .message-edit {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
}
.element-edit > .message-edit > .client-data-message,
.element-edit > .client-data-message {
  display: block;
  width: 100%;
  margin-top: 6px;
}
.element-edit .p-dropdown,
.element-edit .ui-dropdown,
.element-edit .p-inputtext,
.element-edit .ui-inputtext {
  width: 100% !important;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.top-space {
  margin-top: 0;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.action-button {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:hover:not(:disabled) {
  background: #044ea7;
}
.undo-action-button {
  width: 137px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.undo-action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.undo-action-button:hover {
  background: #044ea7;
}
button.undo-action-button:hover .undo-action-button-label {
  color: #ffffff;
}
@media only screen and (max-width: 900px) {
  .container-header {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10px;
    width: 100%;
  }
  .title,
  .sub-title {
    margin-left: 20px;
    margin-top: 10px;
    width: 100%;
  }
  .product-itens {
    flex-direction: column;
    align-items: stretch;
    padding: 4px;
    width: 100%;
  }
  .element-edit {
    font-size: 15px;
    line-height: 22px;
    margin-top: 8px;
    width: 100%;
  }
  .space-top,
  .space-first,
  .space-second {
    margin-left: 0 !important;
  }
  .button-position {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    width: calc(100% - 32px);
    margin: 16px 16px 0;
    padding-top: 14px;
    padding-bottom: 0;
    gap: 10px;
  }
  .action-button,
  .undo-action-button {
    width: 120px;
    height: 42px;
    margin-right: 0;
    margin-top: 10px;
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding: 8px;
    width: 100%;
  }
  .title {
    font-size: 22pt;
    margin-left: 0;
    line-height: 36px;
    width: 100%;
  }
  .sub-title {
    font-size: 10pt;
    margin-left: 0;
    line-height: 30px;
    margin-top: 0;
    width: 100%;
  }
  .product-itens {
    padding: 2px;
    width: 100%;
  }
  .element-edit {
    font-size: 14px;
    line-height: 20px;
    margin-top: 6px;
    width: 100%;
  }
  .button-position {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    width: calc(100% - 32px);
    margin: 14px 16px 0;
    padding-top: 12px;
    padding-bottom: 0;
  }
  .action-button,
  .undo-action-button {
    width: 100px;
    height: 38px;
    margin-right: 0;
    margin-top: 8px;
  }
}
@media only screen and (max-width: 500px) {
  .container {
    padding: 4px;
    width: 100%;
  }
  .title {
    margin-left: 0;
    font-size: 18pt;
    line-height: 28px;
    width: 100%;
  }
  .sub-title {
    font-size: 9pt;
    margin-left: 0;
    line-height: 22px;
    width: 100%;
  }
  .space-top,
  .space-first,
  .space-second {
    margin-left: 0;
  }
  .margin-btn {
    margin-right: 30px;
  }
  .margin-btn-right {
    margin-right: 40px;
  }
  .container-header {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 5px;
    width: 100%;
  }
  .product-itens {
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    width: 100%;
  }
  .element-edit {
    font-size: 13px;
    line-height: 18px;
    margin-top: 4px;
    width: 100%;
  }
  .button-position {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    width: calc(100% - 32px);
    margin: 14px 16px 0;
    padding-top: 12px;
    padding-bottom: 0;
  }
  .action-button,
  .undo-action-button {
    width: 90px;
    height: 32px;
    margin-right: 0;
    margin-top: 6px;
  }
}
.product-itens {
  padding: 8px 36px 0;
  max-width: 1240px;
  margin: 0 auto;
}
.product-itens > .element-edit {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
  padding: 0 12px 16px;
}
.product-itens > .message-edit {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  width: 100%;
  margin: 0;
  padding: 0 !important;
}
.product-itens > .message-edit > .element-edit {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
  padding: 0 12px 16px;
}
.product-itens > .message-edit > .element-edit:only-child {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.product-itens > .message-edit:first-of-type > .element-edit:nth-child(1) {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.product-itens > .message-edit:first-of-type > .element-edit:nth-child(2) {
  flex: 0 0 66.6667% !important;
  max-width: 66.6667% !important;
}
.product-itens > .message-edit:first-of-type > .element-edit:nth-child(3) {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.space-first,
.space-second {
  margin-left: 0 !important;
}
@media only screen and (max-width: 768px) {
  .product-itens {
    padding: 8px 16px 0;
  }
  .product-itens > .element-edit,
  .product-itens > .message-edit > .element-edit {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .product-itens > .message-edit:first-of-type > .element-edit:nth-child(1),
  .product-itens > .message-edit:first-of-type > .element-edit:nth-child(2),
  .product-itens > .message-edit:first-of-type > .element-edit:nth-child(3) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
/*# sourceMappingURL=coverage-details-edit.component-JJWF4BQ2.css.map */
